import React, { useEffect, useState } from "react";
import List from "@mui/material/List";
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import ListItem from "@mui/material/ListItem";
import TranslateOutlinedIcon from "@mui/icons-material/TranslateOutlined";
import { StorageItems } from "../../../utils/storageItems";
import { darkModeBackgroud } from "../../../utils/constants";
import { useLanguageStore } from "../../../store/useLanguageStore";
import { useDarkModeStore } from "../../../store/useDarkModeStore";

const TranslateBtn = ({ styleClass, color }: { styleClass?: string, color?: string }) => {
    const { language, setLanguage } = useLanguageStore();
    const { darkMode } = useDarkModeStore();
    const [changeLanguage, setChangeLanguage] = useState<HTMLElement | null>(null);

    const handleLanguageClick = (event: React.MouseEvent<HTMLButtonElement>) => setChangeLanguage(event.currentTarget);

    const handleLanguageChange = (lang: string) => {
        localStorage.setItem(StorageItems.APPLANGUAGE, lang); // Save only the language key
        const selectedLanguage =
            lang === "Albania"
                ? require("../../../languages/sq-al.json")
                : require("../../../languages/en-us.json");

        setLanguage(selectedLanguage); // Update the language state
        setChangeLanguage(null); // Close the popover
    };

    useEffect(() => {
        // Load the saved language key from localStorage on component mount
        const savedLanguage = localStorage.getItem(StorageItems.APPLANGUAGE) || "English"; // Default to English
        const initialLanguage =
            savedLanguage === "Albania"
                ? require("../../../languages/sq-al.json")
                : require("../../../languages/en-us.json");

        setLanguage(initialLanguage); // Set the language based on the saved key
    }, [setLanguage]);

    return (
        <React.Fragment>
            <Button
                aria-describedby={Boolean(changeLanguage) ? "simple-popover" : undefined}
                className="button-hover-circle ms-auto icon-sidebar-top-color"
                variant="text"
                title={language["ChangeLanguage"]}
                onClick={handleLanguageClick}
            >
                <TranslateOutlinedIcon
                    sx={{
                        width: "22px",
                        height: "22px",
                        color: color ? color : darkMode ? "white" : "var(--text-theme-color)",
                    }}
                />
            </Button>
            <Popover
                anchorEl={changeLanguage}
                open={Boolean(changeLanguage)}
                onClose={() => setChangeLanguage(null)}
                id={Boolean(changeLanguage) ? "simple-popover" : undefined}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                sx={{
                    "& .MuiPopover-paper": {
                        marginLeft: "-70px",
                    },
                }}
            >
                <List style={{ background: darkMode ? darkModeBackgroud : "white" }}>
                    {["Albania", "English"].map((lang) => (
                        <ListItem
                            key={lang}
                            role="button"
                            className="item-hover-background"
                            onClick={() => handleLanguageChange(lang)}
                            style={
                                language["Language"] === lang
                                    ? {
                                        color: "#696CFF",
                                        background: "rgba(105, 108, 255, 0.08)",
                                    }
                                    : { color: darkMode ? "white" : "black" }
                            }
                        >
                            {lang}
                        </ListItem>
                    ))}
                </List>
            </Popover>
        </React.Fragment>
    );
};

export default TranslateBtn;
